// Import DOM purify.
import DOMPurify from 'dompurify';

/**
 * Sanitize HTML string using DOMPurify.
 * 
 * @param html String to be sanitized.
 * @returns Sanitized string.
 */
export const sanitizeHtml = (html: string): string => DOMPurify.sanitize(html);
